import { DashboardLayout } from "layouts/dashboard.layout";
import KitList from "./components/kit-list.component";

export function ResourceKitPage() {
  return (
    <DashboardLayout>
      <KitList />
    </DashboardLayout>
  );
}
